<div class="LoadingOverlay" *ngIf="isLoading" [@loadingLayout] [class._is-fixed]="isFixed">
  <pf-loading-spinner></pf-loading-spinner>
</div>

